var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"type":_vm.status ? 'success' : 'warning',"size":_vm.size},on:{"click":_vm.doUse}},[_c('i',{staticClass:"fa",class:[_vm.status ? 'fa-unlock' : 'fa-lock']}),_vm._v(" "+_vm._s(_vm.status? '点击启用' : '点击停用')+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }